import axios from 'axios';
import { saveAs } from 'file-saver';

const QR_CODE_URL = '/api/ts/qr-codes';

export class QrCodeService {
  // Get the token from localStorage or wherever it's stored
  private static getAuthToken() {
    return localStorage.getItem('token'); // Adjust based on your storage choice
  }

  static async generateQrCodePdf({
    totalQrCodes,
    qrRow,
    qrCol,
    qrCopy
  }: {
    totalQrCodes: number;
    qrRow: number;
    qrCol: number;
    qrCopy: number;
  }) {
    try {
      const token = this.getAuthToken(); // Get token
      const response = await axios.post(
        `${QR_CODE_URL}/generate-pdf`,
        { numQRCodes: totalQrCodes, qrRow, qrCol, qrCopy },
        {
          headers: {
            'x-auth': token || '',
          },
          responseType: 'blob',
        },
      );

      // Check if the response is a PDF
      if (response.headers['content-type'] === 'application/pdf') {
        // Create a Blob from the PDF data
        const pdfBlob = new Blob([response.data], { type: 'application/pdf' });

        // Create an invisible link element
        const link = document.createElement('a');

        // Create an object URL for the Blob and set it as the href
        const url = URL.createObjectURL(pdfBlob);
        link.href = url;

        // Set the desired filename for the downloaded file
        link.download = 'qr-codes.pdf';

        // Append the link to the body (it won't be visible)
        document.body.appendChild(link);

        // Trigger the download by programmatically clicking the link
        link.click();

        // Clean up: remove the link element and revoke the object URL
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      } else {
        console.log(response.headers['content-type']);
        throw new Error('Failed to retrieve PDF: Incorrect content type.');
      }
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        'Error generating QR code PDF';
      console.error(errorMessage);
      throw new Error(errorMessage);
    }
  }
}
